// extracted by mini-css-extract-plugin
module.exports = {"chips":"BlogChips_chips__3n8z5","chip":"BlogChips_chip__BRW8P"};